import type { Article } from "@/mocks/articles";

export default function ArticleTimeline({ article }: { article: Article }) {
  return (
    <section aria-label="事件时间线" className="mt-12 rounded-lg border border-background-200 bg-background-100 p-5 md:p-7">
      <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
        <span className="flex h-5 w-5 items-center justify-center text-primary-500">
          <i className="ri-history-line"></i>
        </span>
        事件时间线
      </h2>
      <p className="mt-2 text-xs text-foreground-500">按公开信息可确认的时间节点排列，未经证实的时间点不予收录。</p>

      <ol className="mt-6 space-y-0">
        {article.timeline.map((item, index) => (
          <li key={`${item.date}-${index}`} className="relative flex gap-4 pb-6 last:pb-0">
            <div className="flex flex-none flex-col items-center">
              <span className="flex h-3 w-3 items-center justify-center rounded-full border-2 border-primary-500 bg-background-50"></span>
              {index < article.timeline.length - 1 && (
                <span className="mt-1 w-px flex-1 bg-background-300"></span>
              )}
            </div>
            <div className="pb-1">
              <p className="font-heading text-xs font-semibold tracking-wide text-primary-600 md:text-sm">
                {item.date}
              </p>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">{item.text}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}